export default "__VITE_ASSET__vXEpKdIM__"